enum VisitType {
	APPOINTMENT = 'APPOINTMENT',
    CONSULTATION = 'CONSULTATION',
    URGENCY = 'URGENCY',
    PHARMACY = 'PHARMACY'
}

export default VisitType;